import { render, staticRenderFns } from "./BlockquoteIcon.vue?vue&type=template&id=d24595d4"
import script from "./BlockquoteIcon.vue?vue&type=script&lang=js"
export * from "./BlockquoteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports